var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 7,
    fill: "url(#paint0_linear_937_2448)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4193 14.6691C9.8335 15.2549 9.8335 16.1977 9.8335 18.0833V29.9167C9.8335 31.8023 9.8335 32.7451 10.4193 33.3309C11.0051 33.9167 11.9479 33.9167 13.8335 33.9167H34.1668C36.0524 33.9167 36.9953 33.9167 37.581 33.3309C38.1668 32.7451 38.1668 31.8023 38.1668 29.9167V18.0833C38.1668 16.1977 38.1668 15.2549 37.581 14.6691C36.9953 14.0833 36.0524 14.0833 34.1668 14.0833H13.8335C11.9479 14.0833 11.0051 14.0833 10.4193 14.6691ZM14.0835 17.3333C13.5312 17.3333 13.0835 17.7811 13.0835 18.3333C13.0835 18.8856 13.5312 19.3333 14.0835 19.3333H16.9168C17.4691 19.3333 17.9168 18.8856 17.9168 18.3333C17.9168 17.7811 17.4691 17.3333 16.9168 17.3333H14.0835ZM30.0835 29.6667C30.0835 29.1144 30.5312 28.6667 31.0835 28.6667H33.9168C34.4691 28.6667 34.9168 29.1144 34.9168 29.6667C34.9168 30.219 34.4691 30.6667 33.9168 30.6667H31.0835C30.5312 30.6667 30.0835 30.219 30.0835 29.6667ZM26.2502 24C26.2502 25.2427 25.2428 26.25 24.0002 26.25C22.7575 26.25 21.7502 25.2427 21.7502 24C21.7502 22.7574 22.7575 21.75 24.0002 21.75C25.2428 21.75 26.2502 22.7574 26.2502 24ZM28.2502 24C28.2502 26.3472 26.3474 28.25 24.0002 28.25C21.653 28.25 19.7502 26.3472 19.7502 24C19.7502 21.6528 21.653 19.75 24.0002 19.75C26.3474 19.75 28.2502 21.6528 28.2502 24Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_937_2448",
    x1: 23.5,
    y1: 0,
    x2: 23.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#695020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.9b33d5ae408b688e1c410c44daa43185.svg";
export { ForwardRef as ReactComponent };